import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { PaymentV2Service, StorageService, UtilService, VariablesService, VwoService } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';

@Component({
  selector: 'app-payment-sip-slabs',
  templateUrl: './payment-sip-slabs.component.html',
  styleUrls: ['./payment-sip-slabs.component.scss']
})
export class PaymentSipSlabsComponent implements OnInit, OnChanges {

  @Input() config: IPaymentSipConfig;
  @Output() amountEmit = new EventEmitter();
  @Output() setCurrency = new EventEmitter();
  @ViewChild('otherInput') otherInput: ElementRef<HTMLElement>;
  @ViewChild('manual_input') manualInput: ElementRef;
  slabsForm: FormGroup | any;
  label = 'Other Amount';
  prevCur;
  amountValidators;
  other = false;
  param;
  placeHolder;
  activeOtherInput;
  max_donation = 50000000;
  nudge: any = false;
  sessionNudge;

  constructor(
    public paymentV2: PaymentV2Service,
    public util: UtilService,
    public actroute: ActivatedRoute,
    public vars: VariablesService,
    public vwo: VwoService,
    public storageServie: StorageService
  ) { }

  ngOnChanges() {
    if (this.slabsForm && this.config.currency !== this.prevCur && this.config.paymentDetails) {
      this.prevCur = this.config.currency;
      this.slabsForm.get('amount').setValidators(this.getAmountValidators());
      // this.slabsForm.get('amount').setValue(this.config.amount);
      this.setAmount(this.config.paymentDetails.default_amount);
    }
    this.sessionNudge = this.storageServie.getFromSession('nudge');
    if (this.vwo.fifty_rupee_nudge_AB() && (this.config?.amount <= 99 || this.config?.amount >= 151) && this.nudge && !this.storageServie.getFromSession('nudge')) {
      this.nudge = false;
    }
    if(this.config.amount && this.slabsForm?.get('amount')) {
      this.slabsForm.get('amount').setValue(this.config.amount);
    }
  }

  ngOnInit() {
    this.param = this.actroute.snapshot.queryParams;
    this.initForm();
    this.prevCur = this.config.currency;
  }

  getAmountValidators() {
    return [
      Validators.required,
      Validators.pattern(/^[0-9]+$/),
      Validators.min(this.config.paymentDetails.min_donation), Validators.max(50000000), Validators.minLength(1)
    ];
  }

  initForm() {
    this.slabsForm = new FormGroup({
      amount: new FormControl(this.config.amount, this.getAmountValidators()),
    });
  }

  setAmount(amount) {
    if (this.slabsForm?.get('amount')?.value === amount && this.config?.showTipCard) {
      amount = 0;
    }
    this.slabsForm.setValue({ amount: +amount || 0 });
    this.amountEmit.emit(+amount || 0);
  }

  showOtherInput() {
    this.activeOtherInput = true;
    if (this.label) {
      this.label = '';
      this.otherInput.nativeElement.style.display = 'flex';
    }
    setTimeout(() => {
      this.manualInput.nativeElement.focus();
    }, 10);
  }

  setAmountWithCurrency(amount, currency) {
    return this.util.formatAmount(amount, currency);
  }

  settoOther() {
    this.other = true;
    this.showOtherInput();
  }

  showNudge() {
    if (this.vwo.fifty_rupee_nudge_AB()) {
      if (this.config?.amount >= 100 && this.config?.amount <= 150 && !this.nudge && !this.sessionNudge) {
        this.nudge = true;
      }
    }
  }
}
